import AdoptionFormResults from "components/AdoptionFormResults";
import { useLocation } from "react-router-dom";

const ResultsPage = () => {

    const location = useLocation();
    const {results} = location?.state || {};
    
    return (
        <AdoptionFormResults {...{results}} />
    )
}

export default ResultsPage;